/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */

import React, { useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import English from '../../../config/translations/en.json';
import German from '../../../config/translations/de.json';
import Portuguese from '../../../config/translations/pt.json';
import Swedish from '../../../config/translations/se.json';
import Finnish from '../../../config/translations/fi.json';
import Spanish from '../../../config/translations/es.json';
import Hebrew from '../../../config/translations/he.json';
import Slovenian from '../../../config/translations/sl.json';
import French from '../../../config/translations/fr.json';
import Estonian from '../../../config/translations/et.json';
import Latvian from '../../../config/translations/lv.json';

// import { DEFAULT_LOCALE } from '../App/constants';
import projectList from '../../../config/containers/App/projectList';

export const Context = React.createContext();
const project_name = process.env.REACT_APP_PROJECT_NAME;
const DEFAULT_LOCALE = projectList[project_name].language.defaultLang;

const initialLocale = localStorage.getItem('language') || DEFAULT_LOCALE;

// stuff like d&#39 works now;
const decodeHtmlEntities = (value) => {
  if (typeof value !== 'string') return value;
  return value
    .replace(/&#39;|&apos;/g, "'") // '
    .replace(/&quot;/g, '"') // "
    .replace(/&amp;/g, '&') // &
    .replace(/&lt;/g, '<') // <
    .replace(/&gt;/g, '>') // >
    .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec)) // decimals
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => String.fromCharCode(parseInt(hex, 16))); // hex
};

const sanitizeMessages = (messages = {}) => Object.fromEntries(Object.entries(messages).map(([key, val]) => [key, typeof val === 'string' ? decodeHtmlEntities(val) : val]));

const getLanguageMessages = (locale) => {
  switch (locale) {
    case 'en':
      return English;
    case 'de':
      return German;
    case 'pt':
      return Portuguese;
    case 'se':
      return Swedish;
    case 'fi':
      return Finnish;
    case 'es':
      return Spanish;
    case 'he':
      return Hebrew;
    case 'sl':
      return Slovenian;
    case 'fr':
      return French;
    case 'et':
      return Estonian;
    case 'lv':
      return Latvian;
    default:
      return English; // Fallback to English or DEFAULT_LOCALE messages
  }
};

const LanguageProvider = (props) => {
  // console.log("LanguageProvider props ", props);
  const [locale, setLocale] = useState(initialLocale);
  const [messages, setMessages] = useState(sanitizeMessages(getLanguageMessages(initialLocale)));

  useEffect(() => {
    localStorage.setItem('language', locale);
  }, [locale]);

  function selectLanguage(newLocale) {
    setLocale(newLocale);
    setMessages(sanitizeMessages(getLanguageMessages(newLocale)));
  }

  return (
    <Context.Provider value={{ locale, selectLanguage }}>
      <IntlProvider
        locale={locale}
        key={props.locale}
        // messages={props.messages[props.locale]}
        messages={messages}>
        {props.children}
      </IntlProvider>
    </Context.Provider>
  );
};

export default LanguageProvider;
/* LanguageProvider.propTypes = {
  locale: PropTypes.string,
  messages: PropTypes.object,
  children: PropTypes.element.isRequired,
};

const mapStateToProps = createSelector(
  makeSelectLocale(),
  locale => ({
    locale,
  }),
);

export default connect(mapStateToProps)(LanguageProvider); */
